import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IPlanType } from '../interfaces';
import { PlanTypeMapper } from '../mappers';

export type IGetPlanTypesRepoResponse = IRepoResponse<200, IPlanType[]> | IRepoResponse<400 | 500, string>;

export type IGetPlanTypesRepo = IRepo<[any], IGetPlanTypesRepoResponse>;

export const GetPlanTypesRepoType = Symbol.for('GetPlanTypesRepo');

@bind(GetPlanTypesRepoType)
export class GetPlanTypesRepo implements IGetPlanTypesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/tariff/category_list', query) });

      if (result.status === 200) {
        const data: IPlanType[] = result.data.data.map((user) => PlanTypeMapper.toDomain(user));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
